import React from "react"
import Image from "next/image"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import type {
  GeneralLogoContainer,
  ReducedGeneralLogoContainer,
} from "types/cms"
import { parseIconData } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import {
  logoContainer,
  logoContainerColors,
  logoContainerImg,
  logoContainerList,
  logoContainerSvg,
} from "./GeneralLogoContainer.css"
import { isReducedGeneralLogoContainer, isReducedIcon } from "types/typeGuards"
import { colours } from "@shared/ui.design-system"

type Props =
  | (CMSPageProps & GeneralLogoContainer)
  | (CMSPageProps & ReducedGeneralLogoContainer)

export const PRLogos: React.FC<Props> = (props) => {
  const { logosRef, backgroundColour, iconColour } = props
  const getColorVariant = backgroundColour?.replace(/\s+/g, "") as string
  const getIconColorVariant = iconColour?.replace(/\s+/g, "") as string

  if (isReducedGeneralLogoContainer(props)) {
    return (
      <div
        className={`${logoContainerColors[getColorVariant]} ${logoContainer}`}
      >
        <div className={logoContainerList}>
          {logosRef.map((item, index) => {
            if (isReducedIcon(item)) {
              const key = `${item.icon.title}-${index}`
              return (
                <div className={logoContainerSvg} key={key}>
                  <div
                    className={logoContainerColors[getIconColorVariant]}
                    style={{
                      height: "48px",
                      width: "60px",
                      WebkitMask: `url(${item.icon.src}) no-repeat center`,
                      mask: `url(${item.icon.src}) no-repeat center`,
                      backgroundColor: `${iconColour ?? colours.primary.dark}`,
                    }}
                  />
                  <span>{item.label}</span>
                </div>
              )
            }
            const key = `${item.description ?? ""}-${index}`
            return (
              <Image
                className={logoContainerImg}
                alt={item.description}
                key={key}
                src={item.src ?? ""}
                width={300}
                height={60}
              />
            )
          })}
        </div>
      </div>
    )
  }
  // This can be deleted once everything is merged
  return (
    <div className={`${logoContainerColors[getColorVariant]} ${logoContainer}`}>
      <div className={logoContainerList}>
        {logosRef.map((item, index) => {
          if ("icon" in item) {
            const { fields } = item.icon
            const key = `${fields.file.fileName}-${index}`
            const parsedIcon = parseIconData(item)
            return (
              <div className={logoContainerSvg} key={key}>
                <div
                  className={logoContainerColors[getIconColorVariant]}
                  style={{
                    height: "48px",
                    width: "60px",
                    WebkitMask: `url(${parsedIcon.src}) no-repeat center`,
                    mask: `url(${parsedIcon.src}) no-repeat center`,
                    backgroundColor: `${iconColour ?? colours.primary.dark}`,
                  }}
                />
                <span>{parsedIcon.label}</span>
              </div>
            )
          }
          const key = `${item.description ?? ""}-${index}`
          return (
            <Image
              className={logoContainerImg}
              alt={item.description}
              key={key}
              src={item.bynderData?.[0]}
              width={300}
              height={60}
            />
          )
        })}
      </div>
    </div>
  )
}
